<template> 
  <div v-if="item.length!==0">    
    <v-card
      v-for="(temp,i) in item"
      :key="i"
      flat 
      class="my-2"
    >   
      <v-row no-gutters> 
        <v-col
          cols="2"
          sm="4"
          :class="temp && temp.win_number ? 'roundColor' : 'roundCloseColor'"
        >
          <v-container
            fluid
            fill-height
          >
            <v-row
              no-gutters
              class="text-center white--text "
            > 
              <v-col 
                cols="12"
              >
                <h2>{{ roundNumber(temp) }} </h2>
              </v-col>
              <v-col cols="12">
                <h5>{{ $t('rounded-is') }} </h5>
              </v-col>    
            </v-row>   
          </v-container> 
        </v-col> 
        <v-col
          cols="10"
          sm="8" 
          class="text-center px-1"
        >
          <v-row no-gutters>
            <v-col
              cols="12"
              md="6"
            >
              <v-col cols="12">
                <b class="grey--text">{{ $t('lotto-type.three') }} </b> 
              </v-col>
              <v-col cols="12">
                <b 
                  v-if="temp.win_number && temp.win_number.three_up" 
                  :class="classColor (item,i)"
                >
                  {{ (temp.win_number || {}).three_up }}
                </b>
                <b v-else>{{ (temp.room_status || {}).name }}</b>
              </v-col> 
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-col cols="12">
                <b class="grey--text">{{ $t('lotto-type.two') }} </b>
              </v-col>
              <v-col cols="12">
                <b 
                  v-if="temp.win_number && temp.win_number.two_down" 
                  :class="classColor (item,i)"
                >
                  {{ (temp.win_number || {}).two_down }}
                </b>
                <b 
                  v-else
                >
                  {{ (temp.room_status || {}).name }}
                </b>
              </v-col> 
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
export default {   
  props : {
    item : {
      type : Array,
      default : ()=>{}
    }
  },
  methods: {
    roundNumber (temp) { 
      return temp.name.split(' ').slice(-1)[0]   
    },
    classColor (temp,i) {
      return temp.length===1||( i !== temp.length-1 && !temp[i+1].win_number) ? 'orange--text' : ''
    }
  }
}
</script>
<style scoped>
.roundColor {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  background-color: var(--bg-secondary-color); 
} 
.roundCloseColor {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  background-color: #bbbbbb; 
}
</style>